import { EventCategory } from "@prisma/client";

export interface CategoryOwnProps {
  category: EventCategory;
  small?: boolean;
  external?: boolean;
}

export function Category({ small, external, category }: CategoryOwnProps) {
  const style = category.color
    ? { backgroundColor: category.color }
    : undefined;

  const className = small
    ? "text-xs px-2 py-1 rounded-full"
    : "text-md md:text-lg px-2 rounded-md";

  const groupHover = external
    ? "group-hover:text-gray-600 group-hover:bg-white"
    : "group-hover:text-primary-50 group-hover:bg-primary-500";

  return (
    <span
      style={style}
      className={`${className} inline-flex shadow-sm bg-gray-100 text-gray-700 ${groupHover}`}
    >
      {category.name}
    </span>
  );
}
